import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { CloseCircleIcon } from "../../data/iconImage";
import { Card, Form, FloatingLabel, Button, Image } from "react-bootstrap";
import Header from "../../components/Header";
import AuthService from "../../services/auth.service";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [remember, setRemember] = useLocalStorage("Remember", null);
  const [userPassword, setUserPassword] = useState({ email: "", password: "" });

  const handleSubmit = (event) => {
    event.preventDefault();

    setLoading(true);
    AuthService.login(userPassword.email, userPassword.password)
      .then((response) => {
        const { username, company } = JSON.parse(
          atob(response.accessToken.split(".")[1])
        );
        setUser({ ...response, username, company });
        navigate("/choose_company", { replace: true });
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (remember) setUserPassword(remember);
  }, []);

  return (
    <>
      <Helmet>
        <title>เข้าสู่ระบบ</title>
        <meta name="description" content="Login Page" />
      </Helmet>

      <Header />

      <div className="vw-100 vh-100 d-flex justify-content-center align-items-center">
        <Card className="w-xl-25 w-md-50 w-75 p-5 rounded-4">
          <Card.Header className=" bg-transparent border-bottom-0">
            <Card.Title className="fw-medium fs-2 text-center">
              เข้าสู่ระบบ
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <Form onSubmit={handleSubmit}>
              {[
                { name: "email", label: "ชื่อผู้ใช้งาน" },
                { name: "password", label: "รหัสผ่าน" }
              ].map(({ name, label }) => (
                <FloatingLabel key={name} label={label} className="mb-3 fs-4">
                  <Form.Control
                    required
                    type={name}
                    className="p-3"
                    placeholder="โปรดระบุ"
                    onChange={({ target }) => {
                      setUserPassword((prev) => ({
                        ...prev,
                        [name]: target.value
                      }));
                      setRemember(null);
                    }}
                    value={userPassword[name]}
                  />
                  {userPassword[name] && (
                    <span
                      className="position-absolute top-50 end-0 translate-middle"
                      onClick={() =>
                        setUserPassword((prev) => ({ ...prev, [name]: "" }))
                      }
                    >
                      <Image src={CloseCircleIcon} alt="Close Circle Icon" />
                    </span>
                  )}
                </FloatingLabel>
              ))}

              <Form.Check
                type="switch"
                name="remember"
                label="จดจำชื่อผู้ใช้งาน"
                className="mb-3 ps-4 text-dark"
                checked={remember || false}
                onChange={({ target }) =>
                  setRemember(target.checked ? userPassword : null)
                }
              />

              <Button
                type="submit"
                variant="success"
                className="w-100 text-dark rounded-pill fs-4"
              >
                เข้าสู่ระบบ
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
}
